import { render, staticRenderFns } from "./CustomCheckboxElement.vue?vue&type=template&id=8ecf4902&scoped=true&"
import script from "./CustomCheckboxElement.vue?vue&type=script&lang=js&"
export * from "./CustomCheckboxElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecf4902",
  null
  
)

export default component.exports